import CoingeckoConfirmedBadge from './CoingeckoConfirmedBadge'

export default CoingeckoConfirmedBadge
